import React from 'react';
import { TExtraRate, TExtraRateOption } from './types';
import { PayRateCard } from './PayRateCard';

interface ExtraRatesSectionProps {
    extraRates: TExtraRate[];
    isEditing: boolean;
    rateOptions: TExtraRateOption[];
    onUpdateRate: (
        rateId: number,
        updater: (rate: TExtraRate) => TExtraRate,
    ) => void;
    onRemoveRate: (rateId: number) => void;
}

export const ExtraRatesSection: React.FC<ExtraRatesSectionProps> = React.memo(({
    extraRates,
    isEditing,
    rateOptions,
    onUpdateRate,
    onRemoveRate,
}) => {
    const hasRates = extraRates.length > 0;

    return (
        <div className="timesheet-extra-rates">
            <div className="timesheet-extra-rates__header">
                <h3>Additional Rates</h3>
            </div>
            {hasRates ? (
                <div className="timesheet-booking-cards">
                    {extraRates.map(rate => (
                        <PayRateCard
                            key={`rate-${rate.id}`}
                            id={rate.id}
                            headerPills={[
                                { label: 'Rate Code', value: rate.extraRateCode },
                            ]}
                            values={{
                                duration: rate.duration,
                                payRate: rate.freelancerPayPerHour,
                                chargeRate: rate.clientPayPerHour,
                                code: rate.extraRateCode,
                                description: rate.description,
                            }}
                            isEditing={isEditing}
                            canEditCode={isEditing && rate.id < 0}
                            rateOptions={rateOptions}
                            onDurationChange={(id, value) =>
                                onUpdateRate(id, current => ({
                                    ...current,
                                    duration: Number(value) || 0,
                                }))
                            }
                            onPayChange={(id, value) =>
                                onUpdateRate(id, current => ({
                                    ...current,
                                    freelancerPayPerHour: Number(value) || 0,
                                }))
                            }
                            onChargeChange={(id, value) =>
                                onUpdateRate(id, current => ({
                                    ...current,
                                    clientPayPerHour: Number(value) || 0,
                                }))
                            }
                            onCodeChange={(id, value, name) =>
                                onUpdateRate(id, current => ({
                                    ...current,
                                    extraRateCode: value,
                                    description: name || current.description,
                                }))
                            }
                            onDescriptionChange={(id, value) =>
                                onUpdateRate(id, current => ({
                                    ...current,
                                    description: value,
                                }))
                            }
                            onRemove={onRemoveRate}
                        />
                    ))}
                </div>
            ) : (
                <p className="timesheet-extra-rates__empty">
                    No extra rates yet. Add one to include adhoc pay items.
                </p>
            )}
        </div>
    );
});

ExtraRatesSection.displayName = 'ExtraRatesSection';

